/**
 * パスワード変更ページ
 *
 * must_change_password=true の場合は初回変更フォーム、
 * それ以外は通常のパスワード変更フォームを表示する。
 */

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAppDispatch, useAppSelector } from '../app/store';
import { setUser } from '../shared/store/slices/authSlice';
import { PasswordChangeForm } from '../features/auth/ui/PasswordChangeForm';
import { InitialPasswordForm } from '../features/auth/ui/InitialPasswordForm';

const ChangePasswordPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const authUser = useAppSelector((state) => state.auth.user);

  const isInitialChange = user?.mustChangePassword ?? false;

  const handleSuccess = useCallback(() => {
    // must_change_password を即時 false に更新（ProtectedRoute のレース条件を防止）
    if (authUser) {
      dispatch(setUser({ ...authUser, must_change_password: false }));
    }
    // パスワード変更成功後、ホームへ遷移
    navigate('/home', { replace: true });
  }, [navigate, dispatch, authUser]);

  return (
    <div className="min-h-svh flex items-center justify-center bg-[#EEF6F4]">
      <div className="w-full max-w-xl bg-white rounded-2xl shadow-lg px-8 py-8">
        <h1 className="text-xl font-bold text-gray-900 mb-6">
          {isInitialChange ? 'パスワードの設定' : 'パスワードの変更'}
        </h1>

        {isInitialChange ? (
          <InitialPasswordForm onSuccess={handleSuccess} />
        ) : (
          <PasswordChangeForm onSuccess={handleSuccess} />
        )}
      </div>
    </div>
  );
};

export default ChangePasswordPage;
